import { decodeHTML } from 'entities';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { postPAIAE010Choice, postPAIAE010DelChoice } from '../../services/Api';
import { decodeToken, formatDate, hideName } from '../../utils';
const ResumeItem = ({
    item,
    hasDelete = false,
    setResumeList,
    showStar = true,
    showEnvelope = false,
    setPopupSendMailOpen,
    setReceiver,
    className,
    roleAction,
    refreshData,
    detailUrl,
}) => {
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const navigate = useNavigate();
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const [star, setStar] = useState(false);

    useEffect(() => {
        if (item.isChoice === 'Y') {
            setStar(true);
        } else {
            setStar(false);
        }
    }, [item.isChoice]);

    const handleDetail = (id, path) => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && id && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login', { state: { id, path } });
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
        }
    };

    const removeStar = () => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C' && roleAction === 'P') {
            alert('개인회원만 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_P' && roleAction === 'C') {
            alert('치과회원만 이용가능합니다.');
            return;
        }
        if (window.confirm('삭제하시겠습니까?')) {
            setStar(false);
            postPAIAE010DelChoice(item.choiceSeq)
                .then(() => {
                    if (refreshData) {
                        refreshData();
                    } else {
                        setResumeList((prevList) =>
                            prevList.map((resume) => (resume.seq === item.seq ? { ...resume, isChoice: 'N' } : resume)),
                        );
                    }
                })
                .catch((error) => {
                    setStar(true);
                    console.log(error);
                });
        }
    };

    const activeStar = () => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C' && roleAction === 'P') {
            alert('개인회원만 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_P' && roleAction === 'C') {
            alert('치과회원만 이용가능합니다.');
            return;
        }

        setStar(true);
        postPAIAE010Choice({ tblName: 'Resume', refSeq: item.seq, memberID: decode?.memberID })
            .then(({ data }) => {
                if (refreshData) {
                    refreshData();
                } else {
                    setResumeList((prevList) =>
                        prevList.map((resume) =>
                            resume.seq === item.seq ? { ...resume, isChoice: 'Y', choiceSeq: data.seq } : resume,
                        ),
                    );
                }
            })
            .catch((error) => {
                setStar(false);
                console.log(error);
            });
    };

    const handleSendLetter = (memberID, name) => {
        setPopupSendMailOpen(true);
        setReceiver({ id: memberID, name: name });
    };

    return (
        <li>
            <div className={`wrap-column ${hasDelete ? 'col4' : ''}`}>
                <div className="column-left">
                    <div className="wrap-title">
                        <a
                            href={loggedIn ? `/pafaa060-${item?.seq}?from=${detailUrl ? detailUrl : ''}` : '#'}
                            target="_blank"
                            className="item-title maxWidth520"
                            onClick={(e) => {
                                if (!loggedIn) {
                                    e.preventDefault();
                                    alert('로그인 후 이용해주세요');
                                    return;
                                }

                                if (decode?.authorities === 'ROLE_P') {
                                    e.preventDefault();
                                    alert('인재정보는 치과회원만 확인하실 수 있습니다.');
                                    return;
                                }
                            }}
                        >
                            {decodeHTML(item?.title)}
                        </a>

                        {showEnvelope && (
                            <img
                                src="./images/icons/icon-letter-blk.png"
                                alt="icon envelope"
                                className="icon-envelope pointer"
                                onClick={() => handleSendLetter(item?.memberID, item?.nameKor)}
                            />
                        )}
                    </div>
                    <ul className="wrap-link">
                        <li>
                            <span>{item?.resumeClass}</span>
                        </li>
                    </ul>
                    <ul className={`wrap-position ${className ? className : ''}`}>
                        {[
                            { si: item?.resumeRegionSi1, gu: item?.resumeRegionGu1 },
                            { si: item?.resumeRegionSi2, gu: item?.resumeRegionGu2 },
                            { si: item?.resumeRegionSi3, gu: item?.resumeRegionGu3 },
                        ]
                            .filter((item) => item?.si && item?.gu)
                            .map((item, index) => (
                                <li key={index}>
                                    {item?.si} &gt; {item?.gu}
                                </li>
                            ))}
                    </ul>
                </div>
                <div className="column-center">
                    <ul className="wrap-link">
                        <li>
                            <span>{item?.resumeCareer === '001' ? '신입' : '경력'}</span>
                        </li>
                        <li>
                            <span>
                                {item?.resumeForm && item?.resumeForm.includes(',')
                                    ? item.resumeForm.split(',')[0] + ' 외'
                                    : item.resumeForm}
                            </span>
                        </li>
                        <li>
                            <span>
                                {item?.resumeLicense && item?.resumeLicense.includes(',')
                                    ? item.resumeLicense.split(',')[0] + ' 외'
                                    : item.resumeLicense}
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="column-right">
                    <div className="wrap-meta">
                        {showStar && (
                            <Link
                                className={`icon icon-star ${star ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    star ? removeStar() : activeStar();
                                }}
                            />
                        )}

                        {/* <Link
                            onClick={(e) => {
                                e.preventDefault();
                                window.open(
                                    `/pafaa061-${item?.seq}`,
                                    '_blank',
                                    `width=1335,height=${window.screen.height}`,
                                );
                            }}
                        >
                            <i className="icon icon-blank" />
                        </Link> */}
                    </div>
                    <div className="price">{hideName(item?.nameKor)}</div>
                    {(() => {
                        const isToday = moment(item?.modDate).isSame(moment(), 'day');
                        return (
                            <div className={`date ${isToday ? 'update' : ''}`}>
                                {isToday ? 'update' : formatDate(item?.modDate)}
                            </div>
                        );
                    })()}
                </div>
                {hasDelete && (
                    <button type="button" className="cndd__delete" onClick={removeStar}>
                        <i className="icon icon-trash-2"></i>
                    </button>
                )}
            </div>
        </li>
    );
};

export default ResumeItem;
